import { getDefaultRawMaterialDefinition, RawMaterialDefinition } from "./RawMaterial";

export const MtlParser = {
    parse(content: string): RawMaterialDefinition[] {
        const materials: RawMaterialDefinition[] = [];

        if (content.indexOf("\r\n") !== -1) {
            // This is faster than String.split with regex that splits on both
            content = content.replace(/\r\n/g, "\n");
        }

        if (content.indexOf("\\\n") !== -1) {
            // join lines separated by a line continuation character (\)
            content = content.replace(/\\\n/g, "");
        }

        const lines = content.split("\n");

        let currentMaterial: RawMaterialDefinition = getDefaultRawMaterialDefinition();

        for (const line of lines) {
            const trimmedLine = line.trim();
            if (trimmedLine === "" || trimmedLine.startsWith("#")) continue;

            if (trimmedLine.startsWith("newmtl")) {
                if (currentMaterial.name !== "") {
                    materials.push(currentMaterial);
                    currentMaterial = getDefaultRawMaterialDefinition();
                }

                currentMaterial.name = trimmedLine.split(" ")[1];
            } else if (trimmedLine.startsWith("Ka ")) {
                const parts = trimmedLine.split(" ");
                currentMaterial.ambientColor = [
                    parseFloat(parts[1]),
                    parseFloat(parts[2]),
                    parseFloat(parts[3]),
                ];
            } else if (trimmedLine.startsWith("Kd ")) {
                const parts = trimmedLine.split(" ");
                currentMaterial.diffuseColor = [
                    parseFloat(parts[1]),
                    parseFloat(parts[2]),
                    parseFloat(parts[3]),
                ];
            } else if (trimmedLine.startsWith("Ks ")) {
                const parts = trimmedLine.split(" ");
                currentMaterial.specularColor = [
                    parseFloat(parts[1]),
                    parseFloat(parts[2]),
                    parseFloat(parts[3]),
                ];
            } else if (trimmedLine.startsWith("Ns ")) {
                const parts = trimmedLine.split(" ");
                currentMaterial.specularExponent = parseFloat(parts[1]);
            } else if (trimmedLine.startsWith("Ke ")) {
                const parts = trimmedLine.split(" ");
                currentMaterial.emissiveColor = [
                    parseFloat(parts[1]),
                    parseFloat(parts[2]),
                    parseFloat(parts[3]),
                ];
            } else if (trimmedLine.startsWith("illum ")) {
                const parts = trimmedLine.split(" ");
                currentMaterial.illuminationModel = parseInt(parts[1]);
            } else if (trimmedLine.startsWith("d ")) {
                const parts = trimmedLine.split(" ");
                currentMaterial.transparency = 1 - parseFloat(parts[1]);
            } else if (trimmedLine.startsWith("Tr ")) {
                const parts = trimmedLine.split(" ");
                currentMaterial.transparency = parseFloat(parts[1]);
            } else if (trimmedLine.startsWith("Ni ")) {
                const parts = trimmedLine.split(" ");
                currentMaterial.refractiveIndex = parseFloat(parts[1]);
            } else if (trimmedLine.startsWith("Ps ")) {
                const parts = trimmedLine.split(" ");
                currentMaterial.sheen = parseFloat(parts[1]);
            } else if (trimmedLine.startsWith("aniso ")) {
                const parts = trimmedLine.split(" ");
                currentMaterial.anisotropy = parseFloat(parts[1]);
            } else if (trimmedLine.startsWith("anisor ")) {
                const parts = trimmedLine.split(" ");
                currentMaterial.anisotropyRotation = parseFloat(parts[1]);
            } else if (trimmedLine.startsWith("Pc ")) {
                const parts = trimmedLine.split(" ");
                currentMaterial.clearcoatThickness = parseFloat(parts[1]);
            } else if (trimmedLine.startsWith("Pm ")) {
                const parts = trimmedLine.split(" ");
                currentMaterial.metalness = parseFloat(parts[1]);
            } else if (trimmedLine.startsWith("Pr ")) {
                const parts = trimmedLine.split(" ");
                currentMaterial.roughness = parseFloat(parts[1]);
            } else if (trimmedLine.startsWith("Pcr ")) {
                const parts = trimmedLine.split(" ");
                currentMaterial.clearcoatRoughness = parseFloat(parts[1]);
            } else if (trimmedLine.startsWith("map_Kd ")) {
                currentMaterial.diffuseMap = trimmedLine.replace("map_Kd ", "").trim();
            } else if (trimmedLine.startsWith("map_Ks ")) {
                currentMaterial.specularColorMap = trimmedLine.replace("map_Ks ", "").trim();
            } else if (trimmedLine.startsWith("map_Bump ")) {
                const value = trimmedLine.replace("map_Bump ", "").trim();
                if (value.startsWith("-bm")) {
                    const tokens = value.split(" ");
                    const bumpMultiplier = parseFloat(tokens[1]);
                    currentMaterial.bumpMap = tokens[2];
                    currentMaterial.bumpMultiplier = bumpMultiplier;
                } else {
                    currentMaterial.bumpMap = trimmedLine.replace("map_Bump ", "").trim();
                }
            } else if (trimmedLine.startsWith("map_Disp ")) {
                currentMaterial.displacementMap = trimmedLine.replace("map_Disp ", "").trim();
            } else if (trimmedLine.startsWith("map_Ns ")) {
                currentMaterial.specularHighlightMap = trimmedLine.replace("map_Ns ", "").trim();
            } else if (trimmedLine.startsWith("map_refl ")) {
                console.warn(
                    "Please, use PBR material exporter to export roughness and metalness maps"
                );
                // currentMaterial.metalnessMap = trimmedLine.replace("map_refl ", "").trim();
            } else if (trimmedLine.startsWith("map_Pm ")) {
                currentMaterial.metalnessMap = trimmedLine.replace("map_Pm ", "").trim();
            } else if (trimmedLine.startsWith("map_Pr ")) {
                currentMaterial.roughnessMap = trimmedLine.replace("map_Pr ", "").trim();
            } else {
                console.warn(`Unknown mtl line: ${trimmedLine}`);
            }
        }

        if (currentMaterial.name !== "") {
            materials.push(currentMaterial);
        }

        return materials;
    },
};
